import { Announcement } from '../types';

const makeAnnouncementsFormat = (response: { data?: Record<string, unknown>[] } | Record<string, unknown>[]): Announcement[] => {
  const raw = Array.isArray(response) ? response : response?.data || [];
  return raw.map((a) => ({
    ItemID: Number(a.ItemID) || 0,
    Title: String(a.Title || ''),
    Description: String(a.Description || ''),
    MoreLink: String(a.MoreLink || ''),
    ExpireDate: String(a.ExpireDate || ''),
    CreatedByUser: String(a.CreatedByUser || ''),
    CreatedDate: String(a.CreatedDate || ''),
  }));
};

export default makeAnnouncementsFormat;
